import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "@/Pages/Home";
import NoPage from "@/Pages/NoPage";
import OurCommunity from "../Pages/OurCommunity";

function AppRoutes() {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/our_community" element={<OurCommunity />} />
        <Route path="*" element={<NoPage />} />
      </Routes>
    </Router>
  );
}

export default AppRoutes;
